// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__Cfo1W","question":"FAQ_question__MlUVA","answer":"FAQ_answer__MN+zu"};